/* unplugin-vue-components disabled */import { render } from "./tablePagination.vue?vue&type=template&id=6b00b69c"
import script from "./tablePagination.vue?vue&type=script&lang=js"
export * from "./tablePagination.vue?vue&type=script&lang=js"

import "./tablePagination.vue?vue&type=style&index=0&id=6b00b69c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__